module.exports = {
  listItem: {
    foregroundColor: {
      default: 'palette.contrastLow',
      error: 'palette.error',
      warning: 'palette.warning',
      success: 'palette.success',
    },
    selectionVariant: {
      solid: {
        background: {
          color: 'palette.primary',
          opacity: 1,
        },
        text: {
          color: 'palette.backgroundAlt',
        },
        hover: {
          color: 'palette.primary',
          opacity: 0.12
        }
      },
      subtle: {
        background: {
          color: 'palette.primary',
          opacity: 0.06,
        },
        text: {
          color: 'palette.primary',
        },
        hover: {
          color: 'palette.primary',
          opacity: 0.12
        }
      },
    },
  },
};
